import React, { useCallback, useEffect } from 'react';
import $i18n from 'panda-i18n';
import { Dialog } from '@fpxfd/next';
import { useSetState } from 'ahooks';

import FpxTable2 from '@/components/FpxTable2';

import { DialogProps, DialogState } from './index.interface';
import styles from './index.module.scss';
import { VasMatchInventoryColumnWithoutStockQty, VasMatchInventoryColumnWithStockQty } from './datas';

const DialogCom = ({ basicObj, vasInventoryList: list, visible, handleVisible }: DialogProps) => {
  const [state, setState] = useSetState<DialogState>({
    dataSource: [],
  });

  const handleCancel = () => {
    setState({ dataSource: [] });
    handleVisible(false);
  };

  /**
   * 增值服务库存匹配Columns
   */
  const getInventoryMatchColumns = useCallback(() => {
    switch (basicObj?.serviceType) {
      case 'PG':
        return VasMatchInventoryColumnWithoutStockQty; // 拍照
      case 'VVW':
        return VasMatchInventoryColumnWithoutStockQty; // 核实材积重量
      case 'MFC':
        return VasMatchInventoryColumnWithoutStockQty; // 拆箱上架
      default:
        return VasMatchInventoryColumnWithStockQty;
    }
  }, [basicObj]);

  return (
    <>
      <Dialog
        visible={visible}
        style={{ width: '900px' }}
        footer={false}
        title={$i18n.get({ id: 'VasMatchInventory', dm: '库存匹配' })}
        onClose={handleCancel}
      >
        <FpxTable2 dataSource={list} columns={getInventoryMatchColumns()} hasBorder className={styles.tableBox} />
      </Dialog>
    </>
  );
};

export default DialogCom;
